if (!customElements.get('noisycode-sticky-cart')) {
  customElements.define('noisycode-sticky-cart', class NoisycodeStickyCart extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.addEventListener('click', this.onClick.bind(this));
      this.observeMainButton();
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.sectionId) return;
          const source = event.data.html.getElementById(`StickyCart-${this.sectionId}`);
          if (!source) return;
          const sourceInner = source.querySelector('.nc-sticky-cart__inner');
          const currentInner = this.querySelector('.nc-sticky-cart__inner');
          if (sourceInner && currentInner) currentInner.innerHTML = sourceInner.innerHTML;
        });
      }
    }
    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      if (this.observer) this.observer.disconnect();
    }
    onClick(event) {
      const trigger = event.target.closest('[data-nc-sticky-add]');
      if (!trigger || trigger.disabled) return;
      const form = document.getElementById(this.dataset.targetForm);
      const mainButton = form ? form.querySelector('[name="add"]') : null;
      if (mainButton && !mainButton.disabled) mainButton.click();
    }
    observeMainButton() {
      const mainButton = document.getElementById(this.dataset.observeButton);
      if (!mainButton || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver((entries) => {
        this.classList.toggle('is-hidden', entries[0].isIntersecting);
      }, { threshold: 0.15 });
      this.observer.observe(mainButton);
    }
  });
}
